import React, { useState } from "react";
import tutoringData from "../data/tutoring.js";
import { Fade } from "react-awesome-reveal";
import logo from "../assets/gatorhead.png";
import "./Programs.css";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
/* <Route path="/programs" element={<Programs />} /> */
const Programs = () => {
  const [openCourses, setOpenCourses] = useState({});
  const [openCategories, setOpenCategories] = useState({});
  const [password, setPassword] = useState("");
const [isAuthenticated, setIsAuthenticated] = useState(false);

const correctPassword = "WELOVEEBOARD";
  const toggleCourse = (category, course) => {
  const courseKey = `${category}-${course}`;

  setOpenCourses({
    ...openCourses,
    [courseKey]: !openCourses[courseKey],
  });
};
const toggleCategory = (category) => {
  setOpenCategories({
    ...openCategories,
    [category]: !openCategories[category],
  });
};
const handleSubmit = (e) => {
  e.preventDefault();

  if (password === correctPassword) {
    setIsAuthenticated(true);
  } else {
    alert("Incorrect password, please try again.");
  }
};
  return (
     <div>
    {isAuthenticated ? (

    <div className="programs-div">
     <div className="programs-faux-title"></div>

<div className="programs-title-div">

  <div className="programs-divider"></div>

  <Fade triggerOnce>
    <div className="programs-title-container">
      <img
        className="programs-image"
        src={logo}
        alt=""
      />

      <h1 className="programs-title">
        Programs
      </h1>
    </div>
  </Fade>

  <div className="programs-divider"></div>
</div>
<div className="programs-tutoring-section">
  <h1 className="programs-tutoring-title">Tutoring</h1>

  <div className="programs-tutoring-divider"></div>

  <p className="programs-tutoring-description">
    FGLP offers peer tutoring to help our members succeed in challenging
    courses. Our officers have experience in a variety of subjects and are
    available to help explain concepts, review material, and prepare for
    assignments and exams.
  </p>
 <div className="programs-courses-section">

  {Object.entries(tutoringData).map(([category, courses]) => {

    const categoryOpen = openCategories[category];

    return (
      <div
        className="programs-course-category"
        key={category}
      >

        <div className="programs-category-subtitle-div">

          <div className="programs-course-category-title">
            {category}
          </div>

          <MdOutlineKeyboardArrowDown
            className="programs-category-button"
            size={45}
            onClick={() => {
              toggleCategory(category);
            }}
          />

        </div>



        {categoryOpen ? (
          <div className="programs-category-content">

            {courses.map((course) => {

              const courseKey = `${category}-${course.course}`;
              const isOpen = openCourses[courseKey];

              return (
                <div
                  className="programs-course-dropdown"
                  key={course.course}
                >

                  <div className="programs-course-subtitle-div">

                    <div className="programs-course-subtitle">
                      {course.course}
                    </div>

                    <MdOutlineKeyboardArrowDown
                      className="programs-course-subtitle-button"
                      size={35}
                      onClick={() => {
                        toggleCourse(category, course.course);
                      }}
                    />

                  </div>

               


                  {isOpen ? (
                    <div className="programs-course-content">

                      <div className="programs-course-content-title">
                        Tutors
                      </div>

                      {course.tutors.map((tutor) => {
                        return (
                          <div
                            className="programs-tutor"
                            key={tutor.name}
                          >
                            <div className="programs-tutor-name">
                              {tutor.name}
                            </div>

                            <div className="programs-tutor-contact">
                              Contact Information: {tutor.contact}
                            </div>
                          </div>
                        );
                      })}

                      <div className="programs-tutoring-notice">
                        Please contact an officer at least 48 hours in advance.
                        Include the specific topic(s) you need help with so they
                        can prepare.
                      </div>

                    </div>
                  ) : (
                    <div></div>
                  )}

                </div>
              );
            })}

          </div>
        ) : (
          <div></div>
        )}

      </div>
    );
  })}

</div>
</div>
</div>
) : (

      <div className="programs-login-container">

        <form
          onSubmit={handleSubmit}
          className="programs-login-form"
        >

          <h1 className="programs-login-title">
            Programs Login
          </h1>

          <div className="programs-login-field">

            <label
              htmlFor="password"
              className="programs-login-label"
            >
              Enter Password:
            </label>

            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="programs-login-input"
            />

          </div>

          <button
            type="submit"
            className="programs-login-button"
          >
            Submit
          </button>

        </form>

      </div>

    )}
  </div>
  );
};

export default Programs;